export default "__VITE_ASSET__AYoCh7sl__"